import {RetailerWebScreen} from '../RetailerWebScreen';
import {ContactUsSection} from './sections/ContactUs';
import {DemoVideoSection} from './sections/DemoVideoSection';
import {FAQSection} from './sections/FAQSection';
import {HeroSection} from './sections/HeroSection';
import {KeyFeaturesSection} from './sections/KeyFeaturesSection';

export const LandingScreen = () => {
    const currentUrl = window.location.hostname;
    let shouldShowHomeScreen = true;
    const paths = currentUrl.split('.');
    if (currentUrl.indexOf('localhost') !== -1) {
        if (paths.length === 2) {
            shouldShowHomeScreen = false;
        }
    } else {
        if (paths.length === 3) {
            shouldShowHomeScreen = false;
        }
    }
    if (!shouldShowHomeScreen) {
        const subDomain = paths[0];
        if (!(subDomain === 'www' || subDomain === 'http' || subDomain === 'https')) {
            return <RetailerWebScreen subDomain={subDomain} />;
        }
    }
    return (
        <div>
            <HeroSection />
            <KeyFeaturesSection />
            {/* <PricingSection /> */}
            <DemoVideoSection />
            <FAQSection />
            <ContactUsSection />
        </div>
    );
};
